import { Box, IconButton, Link, Typography } from "@mui/material";
import React from "react";
import InstagramIcon from "@mui/icons-material/Instagram";
import { FaYoutube } from "react-icons/fa";
import { FaTiktok } from "react-icons/fa";
import { FaTwitter } from "react-icons/fa";


const LandingPageFooter = () => {
  return (
    <Box
      sx={{
        // width: "100vw",

        width: "100%",
        maxWidth: "100%",
        background: "#F46454",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        paddingY: "20px",
      }}
    >
      <Typography variant="h3" color="white">
        صفحات تهمك
      </Typography>
      <Box
        component={"h3"}
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Link
          href="/privacy-policy"
          sx={{
            textDecoration: "none",
            color: "white",
            marginBottom: "8px",
            cursor: "pointer",
          }}
        >
          سياسة الخصوصية
        </Link>
        <Link
          href="/about-us"
          sx={{
            textDecoration: "none",
            color: "white",
            marginBottom: "8px",
            cursor: "pointer",
          }}
        >
          من نحن
        </Link>
        <Link
          href="/contact-us"
          sx={{
            textDecoration: "none",
            color: "white",
            marginBottom: "8px",
            cursor: "pointer",
          }}
        >
          اتصل بنا
        </Link>
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: 5,
        }}
      >

        <IconButton href="https://x.com/yallafallasa">
          <FaTwitter color="white" />
        </IconButton>

        <IconButton href="https://www.youtube.com/@yallafallasa">
          <FaYoutube color="white" />
        </IconButton>
        <IconButton href="https://www.instagram.com/yallafallasa/">
          <InstagramIcon
            sx={{
              color: "white",
            }}
          />
        </IconButton>
        <IconButton href="https://www.tiktok.com/@yallafallasa">
          <FaTiktok color="white" />
        </IconButton>
      </Box>
    </Box>
  );
};

export default LandingPageFooter;
